import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "flickity/css/flickity.css";
import "./callout_carousel.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
